export type FormSteps =
  | 'login'
  | 'signupType'
  | 'species'
  | 'petDetails'
  | 'petHistory'
  | 'ownerDetails'
  | 'breederDetails'
  | 'policyStartDate'
  | 'declaration'
  | 'review'
  | 'confirmation';

export type FormPages =
  | 'login'
  | 'signup-type'
  | 'species'
  | 'details'
  | 'owner-details'
  | 'cover'
  | 'review'
  | 'confirmation';

export const indexPage: FormPages = 'login';
export const indexStep: FormSteps = 'login';

export const topLevelSteps = [
  'species',
  'petDetails',
  'activityLevel',
  'review',
  'signupType',
  'ownerDetails',
  'breederDetails',
  'policyStartDate',
  'paymentMethod',
  'confirmation',
];

export const topLevelStepsIE = topLevelSteps;

export const stepToPageMap: Record<FormSteps, FormPages> = {
  login: 'login',
  species: 'species',
  signupType: 'signup-type',
  petDetails: 'details',
  petHistory: 'details',
  ownerDetails: 'owner-details',
  breederDetails: 'owner-details/#breederDetails',
  policyStartDate: 'owner-details',
  declaration: 'cover',
  review: 'review',
  confirmation: 'confirmation',
};

export const stepToPageMapCustomerFirst = stepToPageMap;